import * as React from 'react';
import { Link, Text } from '../../style.css';

interface RegionalContentProps {
  actionHref: string;
  actionText: string;
  mainText: string;
}

const RegionalContent: React.ComponentType<RegionalContentProps> = ({ mainText, actionText, actionHref }) => (
  <React.Fragment>
    <Text fontSize="16px">{mainText}</Text>
    <Link href={actionHref}>
      <Text fontSize="16px">{actionText}</Text>
    </Link>
  </React.Fragment>
);

export default RegionalContent;
